import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  employees: [],
  isLoading: false,
  errors: '',
  message: ''
};

const employeesSlice = createSlice({
  name: 'employees',
  initialState,
  reducers: {
    getAllEmployees: (state, action) => {
      state.employees = action?.payload;
      state.isLoading = true;
      state.errors = '';
    },
    getAllEmployeesSuccess: (state, action) => {
      state.isLoading = false;
      state.employees = action.payload;
      state.errors = '';
    },
    getAllEmployeesFailure: (state, action) => {
      state.isLoading = false;
      state.errors = action.payload;
    }
  }
});

export const { getAllEmployees, getAllEmployeesSuccess, getAllEmployeesFailure } = employeesSlice.actions;
export default employeesSlice.reducer;
